var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b-form-file', {
    ref: _vm.schema.ref,
    attrs: {
      "accept": _vm.schema.accept,
      "state": Boolean(_vm.value),
      "placeholder": _vm.schema.placeholder,
      "drop-placeholder": _vm.schema.dropPlaceholder,
      "multiple": _vm.schema.multiple,
      "file-name-formatter": _vm.schema.formatNames,
      "browse-text": _vm.$t('browse')
    },
    on: {
      "change": function change($event) {
        return _vm.log(_vm.value);
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }